import './styles/element/index.scss'
import { InfiniteScroll, Button, Loading, Switch, Avatar } from 'element-ui'
import { debounce } from 'lodash-es'
import { VxeTablePluginRenderElement } from './utils/vxe-table-plugin-element'
import {
  // 核心
  // VXETable,
  Tooltip,
  Header,
  Footer,
  Edit,
  Column,
  Validator,
  // 表格
  Table,
  interceptor,
} from 'vxe-table'
import {
  PgDrawerPrintTemplateSelect,
  PgPrintImmediate,
  PgTable,
  PgDrawerForm,
  PgDialogForm,
  PgDialogTable,
  PgDialogTableButton,
  PgDialogTableInput,
  PgSelect,
  PgSelectDouble,
  PgSelectTips,
  PgPageEditTable,
  PgPageEditTableDrag,
  PgClickToRouterByBiz,
  PgMultiClickToRouterByBiz,
  PgInputNumber,
  PgCheckbox,
  PgCheckboxGroup,
  PgRadio,
  PgRadioGroup,
  PgInput,
  PgInputTemplate,
  PgInputRange,
  PgPageQueryDrawerSearch,
  PgDrawerSerialSelect,
  PgScanUpdateItems,
  PgDrawerExport,
  PgDialogSelectBorder,
  PgDialogSelectTable,
  PgDialogSelectTableBtn,
  PgDialogSelectReferInput,
  PgDialogSelect,
  PgDrawerSearchTable,
  PgPageFlowChat,
  PgFlashAddMedical,
  PgCriteriaForm,
  PgCriteriaFormDrawer,
  PgTree,
  PgDrawerSearchTablePackageText,
  PgDrawerSearchTableTag,
  PgDrawerSearchTableBatchNumber,
  PgDialogScanEpc,
  PgInputCellEdit,
  PgReadText,
  PgReadTextEditStyle,
  PgReadTextAndRouter,
  PgDatePicker,
  PgDatePickerRange,
  PgDrawerSearchTableBatchNumberBasic,
  PgUploadCard,
  PgUpload,
  PgReadTextRule,
  PgImage,
  PgDialogInputBorder,
  PgExcelAdd,
  PgFilePreviewDialog,
  PgFilePreviewDialogClick,
  PgCheckboxPopover,
  PgLeftFormRightContent,
  PgInputScan,
  PgScanArea,
} from './components/index'

export const panguComponentPlus = {
  install(Vue) {
    Vue.use(InfiniteScroll)
    Vue.use(Loading)
    Vue.component(Button.name, Button)
    Vue.component(Switch.name, Switch)
    Vue.component(Avatar.name, Avatar)
    VxeTablePluginRenderElement(interceptor)
    Vue.use(Edit).use(Validator).use(Column).use(Table).use(Footer).use(Header).use(Tooltip)

    Vue.component('PgDrawerPrintTemplateSelect', PgDrawerPrintTemplateSelect)
    Vue.component('PgPrintImmediate', PgPrintImmediate)
    Vue.component('PgTable', PgTable)
    Vue.component('PgDrawerForm', PgDrawerForm)
    Vue.component('PgDialogForm', PgDialogForm)
    Vue.component('PgSelect', PgSelect)
    Vue.component('PgSelectDouble', PgSelectDouble)
    Vue.component('PgSelectTips', PgSelectTips)
    Vue.component('PgPageEditTable', PgPageEditTable)
    Vue.component('PgPageEditTableDrag', PgPageEditTableDrag)
    Vue.component('PgClickToRouterByBiz', PgClickToRouterByBiz)
    Vue.component('PgMultiClickToRouterByBiz', PgMultiClickToRouterByBiz)
    Vue.component('PgInputNumber', PgInputNumber)
    Vue.component('PgCheckbox', PgCheckbox)
    Vue.component('PgCheckboxGroup', PgCheckboxGroup)
    Vue.component('PgRadio', PgRadio)
    Vue.component('PgRadioGroup', PgRadioGroup)
    Vue.component('PgInput', PgInput)
    Vue.component('PgInputTemplate', PgInputTemplate)
    Vue.component('PgInputRange', PgInputRange)
    Vue.component('PgPageQueryDrawerSearch', PgPageQueryDrawerSearch)
    Vue.component('PgDrawerSerialSelect', PgDrawerSerialSelect)
    Vue.component('PgScanUpdateItems', PgScanUpdateItems)
    Vue.component('PgDrawerExport', PgDrawerExport)
    Vue.component('PgDialogSelectBorder', PgDialogSelectBorder)
    Vue.component('PgDialogSelectTable', PgDialogSelectTable)
    Vue.component('PgDialogSelectTableBtn', PgDialogSelectTableBtn)
    Vue.component('PgDialogSelectReferInput', PgDialogSelectReferInput)
    Vue.component('PgDialogSelect', PgDialogSelect)
    Vue.component('PgDrawerSearchTable', PgDrawerSearchTable)
    Vue.component('PgPageFlowChat', PgPageFlowChat)
    Vue.component('PgDialogTable', PgDialogTable)
    Vue.component('PgFlashAddMedical', PgFlashAddMedical)
    Vue.component('PgCriteriaForm', PgCriteriaForm)
    Vue.component('PgCriteriaFormDrawer', PgCriteriaFormDrawer)
    Vue.component('PgTree', PgTree)
    Vue.component('PgDrawerSearchTablePackageText', PgDrawerSearchTablePackageText)
    Vue.component('PgDrawerSearchTableTag', PgDrawerSearchTableTag)
    Vue.component('PgDrawerSearchTableBatchNumber', PgDrawerSearchTableBatchNumber)
    Vue.component('PgDrawerSearchTableBatchNumberBasic', PgDrawerSearchTableBatchNumberBasic)
    Vue.component('PgDialogScanEpc', PgDialogScanEpc)
    Vue.component('PgInputCellEdit', PgInputCellEdit)
    Vue.component('PgReadText', PgReadText)
    Vue.component('PgReadTextEditStyle', PgReadTextEditStyle)
    Vue.component('PgReadTextAndRouter', PgReadTextAndRouter)
    Vue.component('PgDatePicker', PgDatePicker)
    Vue.component('PgDatePickerRange', PgDatePickerRange)
    Vue.component('PgDialogTableButton', PgDialogTableButton)
    Vue.component('PgDialogTableInput', PgDialogTableInput)
    Vue.component('PgUploadCard', PgUploadCard)
    Vue.component('PgUpload', PgUpload)
    Vue.component('PgReadTextRule', PgReadTextRule)
    Vue.component('PgImage', PgImage)
    Vue.component('PgDialogInputBorder', PgDialogInputBorder)
    Vue.component('PgExcelAdd', PgExcelAdd)
    Vue.component('PgFilePreviewDialog', PgFilePreviewDialog)
    Vue.component('PgFilePreviewDialogClick', PgFilePreviewDialogClick)
    Vue.component('PgCheckboxPopover', PgCheckboxPopover)
    Vue.component('PgLeftFormRightContent', PgLeftFormRightContent)
    Vue.component('PgInputScan', PgInputScan)
    Vue.component('PgScanArea', PgScanArea)
    //注册异步组件
    Vue.component('PgDrawerRfidAsync', () => import('./components/drawer-rfid/src/drawer-rfid.vue'))
    Vue.component('PgDrawerUdiScanAsync', () =>
      import('./components/udi-scan/src/drawer-udi-scan.vue')
    )

    //解决报错ResizeObserver loop completed with undelivered notifications.
    const resizeObserver = window.ResizeObserver
    window.ResizeObserver = class ResizeObserver extends resizeObserver {
      constructor(callback) {
        callback = debounce(callback, 200)
        super(callback)
      }
    }
  },
}
